import script from "./TheCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./TheCoupon.vue?vue&type=script&setup=true&lang=js"

import "./TheCoupon.vue?vue&type=style&index=0&id=3e149f1d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e149f1d"]])

export default __exports__